import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class CoreQuote extends Block {
  render() {
    const { block } = this.props;

    const text = block.originalContent.replace( /(<([^>]+)>)/ig, '')

    // html is already stripped but we need to display &nbsp;
    return <blockquote dangerouslySetInnerHTML={{ __html: text}} />;
  }
}

class CoreQuoteFactory {
  get type() {
    return "core/quote";
  }

  create(props) {
    return <CoreQuote {...props} />;
  }
}

export default CoreQuoteFactory;
